import { DatabaseWrapper } from 'src/app/shared/databases/database.wrapper';
import { Database } from 'src/app/shared/databases/database';
import { DatabaseEnum } from 'src/app/shared/databases/databases.enum';
import { RepConnWrapper } from '../../repconn/repconn.wrapper';
import { ObjectWrapper } from 'src/app/shared/wrappers/object.wrapper';
import { CommonEnums } from 'src/app/shared/common.enums';
import { Attribute } from 'src/app/shared/models/domain/attribute';

export class AzureSynapseWrapper extends DatabaseWrapper {
    constructor(database: Database) {
        super(database);

        this.dbTyp_Id = DatabaseEnum.azuresynapse.ID;
        this.name = DatabaseEnum.azuresynapse.NAME;
        this.code = DatabaseEnum.azuresynapse.CODE;
        this.showClevel = true;
        //data object tabs
        this.showDataObjectPropertiesTab = true;
        this.showDDLOption = true;
        this.showViewDataTabOption = true;
        this.getSchemasOnDbNm = true;
        this.dataObjectConnDatabaseNm = 'Schema';
        this.conn_DbsTabName = 'Schemas';
        this.isShowObjProperties = true;
        this.hideSchemaNmColumn = false;
        this.hideDatabaseNmDbColumn = true;
        this.showRepConnServiceNm = true;
        this.showDataDescription = false;


    }

    validateRepConn(repConnWrapper: RepConnWrapper) {

        if (repConnWrapper.repConn.conn.host == "" || repConnWrapper.repConn.conn.host == undefined) {
            repConnWrapper.inValid_Cds.push('NO_SEVERNAME');
        }

        if (repConnWrapper.repConn.conn.port == "") {
            repConnWrapper.inValid_Cds.push('NO_PORT');
        }

        if (repConnWrapper.repConn.conn_Usr.conn_Usr == "") {
            repConnWrapper.inValid_Cds.push('NO_CONN_APPUSR');
        }

        if (repConnWrapper.repConn.conn_Usr.conn_Usr.indexOf(" ") != -1) {
            repConnWrapper.inValid_Cds.push('NO_WHITE_SPACE');
        }

        if (repConnWrapper.repConn.conn_Usr.usrPasswd == "") {
            repConnWrapper.inValid_Cds.push('NO_PASSWORD');
        }


        if (repConnWrapper.repConn.conn_Dbs.length != 0) {
            if (repConnWrapper.repConn.conn_Dbs[0].databaseNm == "") {
                repConnWrapper.inValid_Cds.push('NO_DATABASE_NM');
            }
        }

        if (repConnWrapper.repConn.conn.access_Token_Flg == 'Y') {
            if (repConnWrapper.repConn.conn.codePage == "Azure Key Vault") {
                if (repConnWrapper.repConn.conn.ssl_trustStore == "")
                    repConnWrapper.inValid_Cds.push('NO_CLIENTID');
                else if (repConnWrapper.repConn.conn.ssl_keyStorePassword == "")
                    repConnWrapper.inValid_Cds.push('NO_CLIENTKEY');
            } else if (repConnWrapper.repConn.conn.codePage == "Java Key Store") {
                if (repConnWrapper.repConn.conn.ssl_keyStore == "")
                    repConnWrapper.inValid_Cds.push('NO_KEYSTORELOC');
                else if (repConnWrapper.repConn.conn.ssl_trustStorePassword == "")
                    repConnWrapper.inValid_Cds.push('NO_KEYSTOREPASS');
            }
        }

        if (repConnWrapper.repConn.conn.flagent_Id == -1) {
            repConnWrapper.inValid_Cds.push('ESM00202');
        }

        if (repConnWrapper.repConn.conn_Dbs.length < 1) {
            repConnWrapper.inValid_Cds.push('NO_DATABASE');
        }
    }

    getAttributeColumns(objectWrapper: ObjectWrapper,
        attributes: Array<Attribute> = new Array<Attribute>(), component: any = null,hideRowSelection:boolean=true): Array<any> {
        return [
            this.attributeTabulator.getCheckBoxColumn(objectWrapper,hideRowSelection),
            this.attributeTabulator.getSrt_Order(),
            this.attributeTabulator.getAttr_Id(),
            this.attributeTabulator.getAttrNm(objectWrapper,component),
            this.attributeTabulator.getAttrDTyp_Id(objectWrapper, attributes, component),
            this.attributeTabulator.getAttrPrec(objectWrapper),
            this.attributeTabulator.getAttrScale(objectWrapper),
            this.attributeTabulator.getMaxFlag(objectWrapper, true),
            this.attributeTabulator.getAttrPiiIdentifierFlag(objectWrapper, true),
            this.attributeTabulator.getEncryptedFlag(objectWrapper, this.isEncryptedFlag),
            // this.attributeTabulator.getCdcFlag(objectWrapper),
            this.attributeTabulator.getNotNullFlag(objectWrapper),
            this.attributeTabulator.getAttrKeyTyp_Id(objectWrapper),
            this.attributeTabulator.getDescription(objectWrapper),
        ]

    }

    getSourceAttributeColumns(objectWrapper: ObjectWrapper, isComplex: boolean, isShowPIIColumn: boolean, isGoogleAnalytics: boolean = false, isEncryptedFlag: boolean, component: any): Array<any> {
        return [
            this.attributeTabulator.getCheckBoxColumn(objectWrapper),
            this.attributeTabulator.getSrt_Order(),
            this.attributeTabulator.getAttr_Id(),
            this.attributeTabulator.getClevel(objectWrapper, isComplex),
            this.attributeTabulator.getAttrNm(objectWrapper,component),
            this.attributeTabulator.getAttrDTyp_Id(objectWrapper),
            this.attributeTabulator.getAttrPrec(objectWrapper),
            this.attributeTabulator.getAttrScale(objectWrapper),
            this.attributeTabulator.getMaxFlag(objectWrapper, true),
            this.attributeTabulator.getAttrPiiIdentifierFlag(objectWrapper, isShowPIIColumn),
            this.attributeTabulator.getEncryptedFlag(objectWrapper, isEncryptedFlag),
            this.attributeTabulator.getLnk_Attr_Id(objectWrapper),
            this.attributeTabulator.getLnk_Attr_Datatype(objectWrapper),
            this.attributeTabulator.getValid_Cd(objectWrapper, component),
        ]
    }

    getLAttributeColumns(objectWrapper: ObjectWrapper, component): Array<any> {
        return [
            this.attributeTabulator.getCheckBoxColumn(objectWrapper),
            this.lAttributeTabulator.getSrt_Order(),
            this.lAttributeTabulator.getLAttr_Id(),
            this.lAttributeTabulator.getLAttrNm(objectWrapper),
            this.lAttributeTabulator.getSelectColumn(objectWrapper),
            this.lAttributeTabulator.getAttrDTypNm(objectWrapper),
            this.lAttributeTabulator.getLAttrPrec(objectWrapper),
            this.lAttributeTabulator.getLAttrScale(objectWrapper),
            this.lAttributeTabulator.getLAttrType(objectWrapper),
            this.lAttributeTabulator.getLAttrFunction(objectWrapper),
            this.lAttributeTabulator.getLAttrmaxFlag(objectWrapper),
            this.lAttributeTabulator.getDistKeyFlag(objectWrapper, component),
            this.lAttributeTabulator.getOrgKeyFlag(objectWrapper),
            this.lAttributeTabulator.getOrderBy(objectWrapper, component),
        ]
    }

    // getRollupSelectAttributeColumns(objectWrapper: ObjectWrapper): Array<any> {
    //     return [
    //         this.attributeTabulator.getCheckBoxColumn(objectWrapper),
    //         this.lAttributeTabulator.getSrt_Order(),
    //         this.lAttributeTabulator.getLAttr_Id(),
    //         this.lAttributeTabulator.getLAttrNm(objectWrapper),
    //         this.lAttributeTabulator.getSelectColumn(objectWrapper),
    //         this.lAttributeTabulator.getAttrDTypNm(objectWrapper),
    //         this.lAttributeTabulator.getLAttrPrec(objectWrapper),
    //         this.lAttributeTabulator.getLAttrScale(objectWrapper),
    //         this.lAttributeTabulator.getLAttrType( objectWrapper ),
    //         this.lAttributeTabulator.getLAttrFunction( objectWrapper),
    //         this.lAttributeTabulator.getDistKeyFlag(objectWrapper),
    //         this.lAttributeTabulator.getOrgKeyFlag(objectWrapper),
    //         this.lAttributeTabulator.getPartFlag(objectWrapper),
    //         this.lAttributeTabulator.getOrderBy(objectWrapper)
    //     ]
    // }


    getConn_DbColumns(repConnWrapper: RepConnWrapper, component: any = ''): Array<any> {
        return [
            this.conn_DbsTabultor.getCheckBoxColumn(repConnWrapper),
            this.conn_DbsTabultor.getSrt_Order(),
            this.conn_DbsTabultor.getName(repConnWrapper),
          //  this.conn_DbsTabultor.getDatabaseNm(repConnWrapper, component),
            this.conn_DbsTabultor.getSchemaNm(repConnWrapper, component),
            this.conn_DbsTabultor.getStgDb_Flag(repConnWrapper)
        ]
    }




}













